import React from 'react';
import {
  TableRow, TableCell,
  ListItem, ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import {
  MUISelect,
  MUITextBox
} from 'components/FormHelpers/FormInputs';
import _ from 'lodash';

import {
  getUIDateFormat, useCtxParseValue, getEmptyValue
} from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import { compose } from 'recompose';
import { withChangeHandlers } from 'helpers/Change';


export const RestrictionType = ({
  restrictionType, handleChange
}) => {
  const restrictionTypeLov = ['PARENT', 'ROSTER OWNER'];
  return (
    <MUISelect
      value={getEmptyValue(restrictionType)}
      name="restrictionType"
      onChange={handleChange}
      validators={['required']}
      errorMessages={['Required Field']}
      title="Restriction Type"
    >
      {_.map(restrictionTypeLov, (item, i) => (
        <ListItem
          button
          key={_.uniqueId('parti_restriction_type_lov_sel')}
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </MUISelect>
  );
};

export const RestrictionTo = ({
  participant, handleChange
}) => (
  <MUITextBox
    title="Restriction To"
    multiline
    rowsMax="2"
    value={getEmptyValue(participant)}
    onChange={handleChange}
    validators={['required', 'maxStringLength:24']}
    errorMessages={['Required Field', 'Maximum 24 characters allowed']}
    name="participant"
  />
);

export const Role = ({ roleType, handleChange }) => {
  const { protocolPartiRestrRoleType } = useCtxParseValue('LOV_PARTICIPATION_RESTR_ROLE_TYPE');
  protocolPartiRestrRoleType.unshift('EMPTY');
  return (
    <MUISelect
      value={getEmptyValue(roleType)}
      name="roleType"
      onChange={handleChange}
      title="Role"
    >
      {_.map(protocolPartiRestrRoleType, (item, i) => (
        <ListItem
          key={_.uniqueId('parti_roletype_lov_sel')}
          button
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </MUISelect>
  );
};


export const StartDate = ({
  startDate, handleDateChange
}) => (
  <MUIDatePicker
    title="Start Date"
    name="startDate"
    onChange={handleDateChange('startDate')}
    value={startDate ? getUIDateFormat(startDate) : ''}
  />
);


export const EndDate = ({
  endDate, handleDateChange
}) => (
  <MUIDatePicker
    title="End Date"
    name="endDate"
    onChange={handleDateChange('endDate')}
    value={endDate ? getUIDateFormat(endDate) : ''}
  />
);


export const DataSource = ({ dataSource }) => (<>{dataSource || 'RSS'}</>);

const Editrestriction = (props) => {
  const {
    cancel,
    reset,
    state,
    handleChange,
    handleDateChange
  } = props;

  const {
    restrictionType,
    participant,
    roleType,
    startDate,
    endDate,
    dataSource,
    esysStatus
  } = state;

  return (
    <TableRow>
      <TableCell>
        <RestrictionType restrictionType={restrictionType} handleChange={handleChange} />
      </TableCell>
      <TableCell>
        <RestrictionTo participant={participant} handleChange={handleChange} />
      </TableCell>
      <TableCell>
        <Role roleType={roleType} handleChange={handleChange} />
      </TableCell>
      <TableCell>
        <StartDate startDate={startDate} handleDateChange={handleDateChange} />
      </TableCell>
      <TableCell>
        <EndDate endDate={endDate} handleDateChange={handleDateChange} />
      </TableCell>
      <TableCell>
        <DataSource dataSource={dataSource} />
      </TableCell>
      <TableCell>
        {esysStatus}
      </TableCell>
      <TableCell align='center'>
        <GridSubmitAction cancel={cancel} reset={reset} />
      </TableCell>
    </TableRow>
  );
};


const EditRestrictionFor = compose(withChangeHandlers)(Editrestriction);

export default EditRestrictionFor;
